import React, { useState, useContext, useCallback } from "react";
import { Spin, Input } from "antd";
import { LoadingOutlined } from "@/utils/antdIcon";
import { LoginFormContext } from "../../utils";
import { BackNav } from "../../comps";
import { InviteUserInfo, SendJoinApproveRes } from "@/types/LoginPage";
import { useTranslation } from "react-i18next";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import InputWithCtr from "@/components/TeamManagement/InputWithCtr";
import { changeEgovUrl } from "@/utils/tools";
import { getWebEnvObj } from "@/utils";
import okPNG from "@/components/UploadBox/imgs/ok.png";
import styles from "../../index.module.less";
const {
  REACT_APP_OSS_BASE_URL = "https://focus-desktop.s3.cn-north-1.jdcloud-oss.com"
} = getWebEnvObj();
enum JoinOtherTeamStatus {
  Init, // 团队码输入页面
  InvitorCheck, // 带加入页面
  WaitingApproval, // 等待审核页面
  Finish // 加入完成页面 目前该状态没用上
}

export default function JoinOtherTeam({ goBack }: { goBack: () => void }) {
  const { t } = useTranslation("common");
  const { service, onGlobalError, authInfo: authData } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  const { authInfo: loginAuthInfo, enterApplication } = useContext(LoginFormContext);
  const authInfo = loginAuthInfo || authData;
  const [teamCode, setTeamCode] = useState<string | undefined>("");
  const [userName, setUserName] = useState<string | undefined>("");
  const [teamInfo, setTeamInfo] = useState<InviteUserInfo>({} as any);
  const [joinResult, setJoinResult] = useState<SendJoinApproveRes | null>(null);
  const [loading, setLoading] = useState(false);
  const [joinStatus, setJoinStatus] = useState(JoinOtherTeamStatus.Init);
  const [errorCode, setErrorCode] = useState(false);
  const [showTips, setShowTips] = useState(false);

  const loadingComp = (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 16, color: "white" }} spin />} />
  );

  function onTeamCodeChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const v: string = e.target.value?.trim()?.toLocaleUpperCase();
    console.log("onTeamCodeChange", v);
    setTeamCode(v);
    if (errorCode) {
      setErrorCode(false);
    }
  }
  function onUserNameChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    setUserName(e.target.value);
  }

  async function checkInviteCodeByTeamCode() {
    if (!teamCode) {
      return;
    }
    try {
      const content: InviteUserInfo = await service.focusService.checkInviteCodeByTeamCode({
        inviteCode: teamCode,
        inviteUserId: authInfo.userId
      });
      // setErrorCode(true);
      if (content) {
        setTeamInfo(content);
        setJoinStatus(JoinOtherTeamStatus.InvitorCheck);
      }
    } catch (e) {
      setErrorCode(true);
      // onGlobalError(e);
    }
  }

  const sendJoinApprove = useCallback(async () => {
    try {
      const content: SendJoinApproveRes = await service.focusService.sendJoinTeamApprove({
        joinType: 4,
        inviteCode: teamInfo.inviteCode,
        inviteUserId: teamInfo.userId,
        name: userName
      });
      if (content) {
        if (content.needApprove) {
          // setJoinResult(content);
          setJoinStatus(JoinOtherTeamStatus.WaitingApproval);
        } else {
          enterApplication(teamInfo);
        }
      }
    } catch (e) {
      // onGlobalError(e);
    }
  }, [userName]);

  const teamCodeInput = (
    <>
      <div>
        <BackNav
          clickHandle={goBack}
          title={t("login.back")}
          subtitle={t("login.inputTeamCode")}
          // desc={t("login.teamCodeDesc")}
        />
      </div>
      <div
        style={{
          paddingBottom: 44
          // marginTop: 9
        }}
      >
        <div className={styles.mobileForm}>
          <span className={styles.mobileInputText}>{t("login.inputTeamCodeText")}</span>
          <div className={styles.mobileInput}>
            <Input
              placeholder={t("login.inputTeamCodePlaceholder")}
              autoComplete="off"
              autoFocus
              allowClear
              maxLength={6}
              value={teamCode}
              className={`${styles.mobileInput} ${errorCode ? styles["warn-info"] : "" }`}
              onChange={onTeamCodeChange}
              style={{marginTop: 8}}
            />
            {errorCode ? (
              <p
                className={styles["warn-info"]}
                style={{
                  marginTop: 10
                }}
              >
                {t("login.teamCodeError")}
              </p>
            ) : null}
            <p
              className={styles["invite-info"]}
              style={{
                marginTop: 12,
                marginBottom: 12
              }}
              onClick={() => {
                setShowTips((pre) => {
                  return !pre;
                });
              }}
            >
              {t("login.teamCodeInviteInfo")}
            </p>
            {showTips ? (
              <p
                className={styles["invite-tips"]}
                style={{
                  marginTop: 2
                }}
              >
                {t("login.teamCodeInviteTips")}<br/>
                {t("login.teamCodeInviteTips2")}
              </p>
            ) : null}
          </div>
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          width: 320,
          bottom: 45
        }}
      >
        <div
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}
          onClick={() => {
            checkInviteCodeByTeamCode();
          }}
          className={styles.btn}
          style={
            !loading && teamCode && teamCode.length
              ? {
                  opacity: 1,
                  cursor: "pointer"
                }
              : {
                background: '#BABFC5'
              }
          }
        >
          {loading && <div>{loadingComp}</div>}
          <div
            style={{
              margin: 12,
              fontSize: 14,
              color: "rgb(255, 255, 255)"
            }}
          >
            {t("nextStep")}
          </div>
        </div>
      </div>
    </>
  );
  const invitorCheck = (
    <>
      <div>
        <BackNav
          clickHandle={() => {
            setJoinStatus(JoinOtherTeamStatus.Init);
          }}
          title={t("login.back")}
          subtitle={t("login.joinTeamUserName", {
            companyName: teamInfo?.teamName || "ceshi"
          })}
          // desc={t("login.inputUserNameDesc", {
          //   companyName: teamInfo?.teamName || "ceshi"
          // })}
        />
      </div>
      <div
        style={{
          paddingBottom: 44
          // marginTop: 9
        }}
      >
        <div className={styles.mobileForm}>
          <span className={styles.mobileInputText}>{t("login.inputUserNameText")}</span>
          <Input
            placeholder={t("login.inputUserNameTextPlaceholder")}
            autoComplete="off"
            allowClear
            autoFocus
            className={styles.mobileInput}
            onChange={onUserNameChange}
            maxLength={50}
            style={{marginTop: 8}}
          />
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          width: 320,
          bottom: 45
        }}
      >
        <div
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}
          onClick={() => {
            if (!loading && userName && userName.length) {
              sendJoinApprove();
            }
          }}
          className={styles.btn}
          style={
            !loading && userName && userName.length
              ? {
                  opacity: 1,
                  cursor: "pointer"
                }
              : {
                background: '#BABFC5'
              }
          }
        >
          {loading && <div>{loadingComp}</div>}
          <div
            style={{
              margin: 12,
              fontSize: 14,
              color: "rgb(255, 255, 255)"
            }}
          >
            {t("login.apply-join")}
          </div>
        </div>
      </div>
    </>
  );
  const WaitingApproval = (
    <div
      style={{
        // textAlign: "center",
        // display: "flex",
        // alignItems: "center",
        // flexDirection: "column"
      }}
    >
      {/* <img
        style={{
          marginTop: 80,
          width: 80,
          height: 80,
          marginBottom: 18
        }}
        src={okPNG}
        alt=""
      />
      <p
        style={{
          marginBottom: 36,
          padding: "12px 24px",
          fontSize: 18,
          fontWeight: 500,
          lineHeight: 1
        }}
      >
        {t("login.waittingApproval")}
      </p> */}
      <BackNav
        clickHandle={goBack}
        title={t("login.back")}
        subtitle={t("login.waittingApproval")}
        titleIcon={<img
          style={{
            width: 24,
            height: 24,
            marginRight: 5
          }}
          src={okPNG}
          alt=""
        />}
      />
      <p
        style={{
          color: "#1B1B1B",
          fontFamily: "PingFang SC",
          fontSize: 14,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "170%" /* 23.8px */
        }}
      >
        {t("login.waittingApprovalDesc", {
          companyName: teamInfo?.teamName || "ceshi"
        })}
      </p>

      <div
        role="button"
        tabIndex={0}
        onKeyDown={() => {}}
        onClick={() => {
          goBack();
        }}
        className={styles.btn}
        style={{
          position: "absolute",
          width: 320,
          bottom: 45,
          opacity: 1,
          cursor: "pointer"
        }}
      >
        <div
          style={{
            margin: 12,
            fontSize: 14,
            color: "rgb(255, 255, 255)"
          }}
        >
          {t("login.done")}
        </div>
      </div>
    </div>
  );
  return (
    <div className={styles.mobileForm}>
      {joinStatus === JoinOtherTeamStatus.Init ? teamCodeInput : null}
      {joinStatus === JoinOtherTeamStatus.InvitorCheck ? invitorCheck : null}
      {joinStatus === JoinOtherTeamStatus.WaitingApproval ? WaitingApproval : null}
    </div>
  );
}
